import { Box, Button, FormGroup, Grid } from "@mui/material";

export const ClosePopup = (props) => {

    const proceedWithClosure = () => {
        //close both popups
        props.handleCloseOverlay();
        props.parentClose();
    }

    const stopTheAction = () => {
        props.handleCloseOverlay();
    }

    return (
        <>
            <Grid container>
                <Grid item md={12} xs={12}>
                    <div className='LandingTopWrapperCss'>
                        <div className='LandingHeadingPopup'>
                            <p className='welcomeText' style={{ textAlign: 'center' }}>All the changes will be lost.</p>
                            <p className='welcomeText'>Are you sure you want to close this window?</p>
                        </div>
                    </div>
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <Box display="flex" justifyContent="center" gap={2}>
                                <Button variant="contained" onClick={stopTheAction}>No</Button>
                                <Button variant="outlined" onClick={proceedWithClosure}>Yes</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>

    );
} 